export default "__VITE_ASSET__e5ed991e__"